import cx, { clsx } from 'clsx';

import type { OAISchema } from '~/types/openapi';
import { isMoreThan } from '~/utils/number';

type Props = OAISchema['MarketSelectProductResponseV2'] & {
  reverse?: boolean;
  className?: string;
};

const CouponDiscountedPrice = ({
  couponDiscountedPrice,
  price,
  reverse = false,
  className,
  priceBeforeDiscount,
}: Props) => {
  return couponDiscountedPrice ? (
    <div
      className={cx(['flex mt-4 flex-col disable-text-size-adjust', className])}
    >
      <div
        className={cx([
          'text-[#3940DA] typo-title100-semibold !leading-[20px]',
          reverse &&
            'inline-flex flex-row-reverse gap-[2px] mr-auto items-center whitespace-nowrap',
        ])}
      >
        <div className="text-[#3940DA] typo-footnote300-semibold">
          나의할인가
        </div>
        <span>{couponDiscountedPrice?.toLocaleString()}원</span>
      </div>
      <p className="mt-0 line-clamp-2 whitespace-pre-line text-description typo-footnote300-semibold">
        {`${price.toLocaleString()}`}원{' '}
      </p>
    </div>
  ) : (
    <p
      className={clsx(
        'mt-4 flex flex-col text-normal typo-title100-semibold',
        className,
      )}
    >
      {price === 0 ? (
        '상담신청 상품'
      ) : (
        <>
          {price.toLocaleString()}원
          {isMoreThan(priceBeforeDiscount, price) && (
            <span className="text-description typo-footnote300-semibold">
              {priceBeforeDiscount.toLocaleString()}원
            </span>
          )}
        </>
      )}
    </p>
  );
};

export default CouponDiscountedPrice;
